import { Button, Popover, makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Popover as BootstrapPopover, OverlayTrigger } from 'react-bootstrap';
import { SketchPicker } from 'react-color';
import { connect } from 'react-redux';
import {
  fetchUserGroups,
  updateUserFields
} from '../../../../redux/actions/app-actions';
import { firebase } from '../../../../firebase';
import { ReactComponent as DeleteButtonSvg } from '../../../../images/delete-btn-light.svg';
import { ReactComponent as PlayButtonSvg } from '../../../../images/play-btn.svg';
import { ReactComponent as ShareButtonSvg } from '../../../../images/share-btn.svg';
import {
  isAITag,
  isKeyIdeaFlag,
  isRetrievalTag
} from '../../../../utils/tagValidatorUtils';
import { splitName } from '../../../../utils/utils';
import RetrievalFeedback from '../../../flags/components/RetrievalFeedback';
import { initializePollyProcess } from '../../../flags/components/pollyProcess';
import ShareFlags from '../../../../components/share-flags/ShareFlags';
import FlagRowFooterInPdfViewer from './FlagRowFooterInPdfViewer';
import FlagRowInPdfViewer from './FlagRowInPdfViewer';
import { isUnmatchedFlag } from '../../../../utils/isUnmatchedFlag';
import WarningSign from '../../../../components/ui/tooltip/WarningSign';

const useStyles = makeStyles((theme) => ({
  button: {
    '&.MuiButton-root:hover': {
      backgroundColor: 'transparent' // Set padding to 0 for the button label
    }
  }
}));

const FlagRowHeaderInPdfViewer = ({
  getUserGroups,
  handleFlagPlay,
  setIsSelectedFlags1,
  handleSelectedDelete,
  setColorUserFields,
  firstMineFlag,
  handleRefreshPdfViewer,
  userFields,
  flagsList,
  handleItemSelect,
  hiddenSelectionCheckbox,
  citationData,
  unhighlightedNotes,
  isPersonalPodcast,
  isFromPdfViewerPage,
  unhighlightedFlags
}) => {
  const classes = useStyles();

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [flagsToShare, setFlagsToShare] = useState([]);
  const [show, setShow] = useState(null);
  const handleShow = (e) => {
    e.stopPropagation(), setShow(e.currentTarget), e.preventDefault();
  };
  const handleClose = () => setShow(false);
  const [showPopup, setShowPopup] = useState(true);
  const [color, setColor] = useState('#f07ec2');
  const [flag, setFlag] = useState(null);
  const [index, setIndex] = useState(0);
  const [currentUserColor, setCurrentUserColor] = useState(true);
  const [circleLeft, setCircleLeft] = useState('5px');

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
    setDisplayColorPicker(!displayColorPicker);
    let values = {};
    values.color = newColor.hex;
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        values.color = newColor.hex;
        await setColorUserFields(token, values);
        handleRefreshPdfViewer(true);
      });
    }
  };
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (flag?.isMine) {
      setDisplayColorPicker(!displayColorPicker);
    }
  };

  const handleCloseColorPicker = (e) => {
    e.stopPropagation();
    setDisplayColorPicker(!displayColorPicker);
    e.preventDefault();
  };

  const handleShareModalOpen = (e, flag) => {
    e.stopPropagation();
    setShareModalOpen(true);
    setFlagsToShare([flag]);
  };

  const handleShareModalClose = () => {
    setShareModalOpen(false);
    handleClose();
  };

  const handleShareModalInit = async (e, flag) => {
    e.stopPropagation();
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await getUserGroups(token, flag?.feedUrl);
      handleShareModalOpen(e, flag);
    }
  };

  const handlePopupClose = () => {
    let values = {};
    setShowPopup(false);
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        values.color = color;
        setColorUserFields(token, values);
      });
    }
  };

  const Popup = ({ onClose }) => {
    const json = JSON.parse(firstMineFlag);
    if (json.flagId === flag?.flagId) {
      return (
        <div
          style={{
            position: 'absolute',
            top: '70px',
            left: '7px',
            padding: '10px',
            backgroundColor: '#e8e8e8',
            borderRadius: '5px',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
            color: '#4d4d4f',
            fontWeight: 'normal',
            width: '200px'
          }}
        >
          <div
            style={{
              content: '',
              display: 'block',
              position: 'absolute',
              left: '1rem',
              top: '-15px',
              borderBottom: '15px solid #e8e8e8',
              borderLeft: ' 15px solid transparent',
              borderRight: '15px solid transparent'
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              cursor: 'pointer'
            }}
            onClick={onClose}
          >
            X
          </div>
          <p style={{ marginTop: '15px' }}>
            {'Click here to change your default highlight color'}
          </p>
        </div>
      );
    } else {
      return null;
    }
  };

  const changeFlag = (e, opt) => {
    e.stopPropagation();
    e.preventDefault();
    const size = flagsList.length;
    if (opt === 'previous') {
      if (flagsList[index - 1] !== undefined) {
        setFlag(flagsList[index - 1]);
        setIndex(index - 1);
        flagsList[index - 1].isMine
          ? setCurrentUserColor(true)
          : setCurrentUserColor(false);
      } else {
        setFlag(flagsList[size - 1]);
        setIndex(size - 1);
        flagsList[size - 1].isMine
          ? setCurrentUserColor(true)
          : setCurrentUserColor(false);
      }
    } else if (opt === 'next') {
      if (flagsList[index + 1] !== undefined) {
        setFlag(flagsList[index + 1]);
        setIndex(index + 1);
        flagsList[index + 1].isMine
          ? setCurrentUserColor(true)
          : setCurrentUserColor(false);
      } else {
        setFlag(flagsList[0]);
        setIndex(0);
        flagsList[0].isMine
          ? setCurrentUserColor(true)
          : setCurrentUserColor(false);
      }
    }
    if (size === 4) {
      setCircleLeft('15px');
    } else if (size === 3) {
      setCircleLeft('10px');
    }
  };

  useEffect(() => {
    setFlag(flagsList[index]);
  }, [flagsList]);

  const open = Boolean(show);
  const id = open ? 'simple-popover' : undefined;
  const popover = {
    position: 'relative',
    zIndex: '2'
  };

  const cover = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px'
  };

  const displayName = () => {
    if (flag && !isAITag(flag.tag)) {
      return splitName(flag.author);
    } else {
      return 'Ai';
    }
  };

  const flagsToPlay = [flag];

  const hasColor =
    userFields &&
    typeof userFields === 'object' &&
    Object.keys(userFields).length > 0 &&
    userFields?.color !== undefined
      ? true
      : false;

  const maxNumOfCircles =
    flagsList?.find((n) => n.isMine) !== undefined && flagsList?.length < 4
      ? flagsList?.length - 1
      : flagsList?.length < 4
      ? flagsList?.length
      : flagsList?.find((n) => n.isMine) !== undefined && flagsList?.length > 4
      ? 2
      : 3;

  const sortedListByMine =
    flagsList?.length > 1
      ? flagsList.sort((a, b) => b.isMine - a.isMine)
      : flagsList;

  const flagId = flagsList[0]?.flagId || null;

  return (
    <div>
      {!isFromPdfViewerPage && (
        <>
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {hasColor ? (
              sortedListByMine?.length === 1 ? (
                <div
                  className="circle-flag"
                  style={{
                    backgroundColor: flag?.isMine ? flag?.color : '#7634a9',
                    cursor: 'pointer'
                  }}
                  onClick={(e) => {
                    handleClick(e);
                  }}
                >
                  {displayName()}
                  {flag?.isMine && displayColorPicker && (
                    <div style={popover}>
                      <div
                        style={cover}
                        onClick={(e) => {
                          handleCloseColorPicker(e);
                        }}
                      />
                      <div style={{ position: 'absolute', top: 20, left: -22 }}>
                        <SketchPicker
                          color={color}
                          onChange={handleColorChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="circle-container"
                  onClick={(e) => {
                    handleClick(e);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {sortedListByMine?.find((n) => n.isMine) !== undefined ? (
                    currentUserColor ? (
                      <>
                        <div
                          style={{ backgroundColor: flag?.color }}
                          className={'circle-pdf circle-mine'}
                        >
                          {displayName()}
                          {flag?.isMine && displayColorPicker && (
                            <div style={popover}>
                              <div
                                style={cover}
                                onClick={(e) => {
                                  handleCloseColorPicker(e);
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 20,
                                  left: -22
                                }}
                              >
                                <SketchPicker
                                  color={color}
                                  onChange={handleColorChange}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        {Array.from({ length: maxNumOfCircles }, (_, index) => (
                          <div
                            key={index}
                            className={`circle-pdf circle${index}`}
                          ></div>
                        ))}
                      </>
                    ) : (
                      <>
                        <div className="circle-pdf">{displayName()}</div>
                        {Array.from({ length: maxNumOfCircles }, (_, index) => (
                          <div
                            key={index}
                            className={`circle-pdf circle1${index}`}
                          ></div>
                        ))}
                        <div
                          style={{
                            backgroundColor: flag?.color,
                            left: circleLeft
                          }}
                          className={'circle-pdf circle-mine-last'}
                        ></div>
                      </>
                    )
                  ) : (
                    <>
                      <div className="circle-pdf">{displayName()}</div>
                      {Array.from({ length: maxNumOfCircles }, (_, index) => (
                        <div
                          key={index}
                          className={`circle-pdf circle0${index}`}
                        ></div>
                      ))}
                    </>
                  )}
                </div>
              )
            ) : sortedListByMine?.length === 1 ? (
              <div
                className="circle-flag"
                style={{
                  backgroundColor: flag?.isMine ? flag?.color : '#7634a9',
                  cursor: 'pointer'
                }}
              >
                {displayName()}
                {flag?.isMine && showPopup && (
                  <Popup onClose={handlePopupClose} />
                )}
              </div>
            ) : (
              <div className="circle-container">
                {sortedListByMine?.find((n) => n.isMine) !== undefined ? (
                  currentUserColor ? (
                    <>
                      <div
                        style={{ backgroundColor: flag?.color }}
                        className={'circle-pdf circle-mine'}
                      >
                        {displayName()}
                        {flag?.isMine && showPopup && (
                          <Popup onClose={handlePopupClose} />
                        )}
                      </div>
                      {Array.from({ length: maxNumOfCircles }, (_, index) => (
                        <div
                          key={index}
                          className={`circle-pdf circle${index}`}
                        ></div>
                      ))}
                    </>
                  ) : (
                    <>
                      <div className="circle-pdf">{displayName()}</div>
                      {Array.from({ length: maxNumOfCircles }, (_, index) => (
                        <div
                          key={index}
                          className={`circle-pdf circle1${index}`}
                        ></div>
                      ))}
                      <div
                        style={{
                          backgroundColor: flag?.color,
                          left: circleLeft
                        }}
                        className={'circle-pdf circle-mine-last'}
                      ></div>
                    </>
                  )
                ) : (
                  <>
                    <div className="circle-pdf">{displayName()}</div>
                    {Array.from({ length: maxNumOfCircles }, (_, index) => (
                      <div
                        key={index}
                        className={`circle-pdf circle0${index}`}
                      ></div>
                    ))}
                  </>
                )}
              </div>
            )}

            {sortedListByMine?.length > 1 ? (
              <>
                <div>
                  <i
                    className="fa fa-chevron-left"
                    aria-hidden="true"
                    style={{
                      color: '#bcbcbc',
                      marginRight: 5,
                      cursor: 'pointer'
                    }}
                    onClick={(e) => {
                      changeFlag(e, 'previous');
                    }}
                  />
                </div>
                <div>
                  <i
                    className="fa fa-chevron-right"
                    aria-hidden="true"
                    style={{ color: '#bcbcbc', cursor: 'pointer' }}
                    onClick={(e) => {
                      changeFlag(e, 'next');
                    }}
                  />
                </div>
              </>
            ) : null}
            {!isFromPdfViewerPage && (
              <div className="name">{`${
                sortedListByMine?.length > 1
                  ? `${flag?.author} + ${sortedListByMine?.length - 1}`
                  : flag?.author
              }`}</div>
            )}

            {unhighlightedFlags?.includes(flagId) && (
              <WarningSign text="This flag could not be highlighted in the PDF Viewer." />
            )}
            <div className="point-menu" onClick={(e) => handleShow(e)}>
              ...
            </div>
            <Popover
              id={id}
              open={open}
              anchorEl={show}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <div className="actions-popover">
                {flag?.isShared ||
                (flag &&
                  (isAITag(flag.tag) ||
                    isPersonalPodcast ||
                    isRetrievalTag(flag.tag))) ? (
                  <></>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      isUnmatchedFlag(flag?.trackPosition) ? (
                        <BootstrapPopover id="popover-basic">
                          This flag cannot be shared with other users
                        </BootstrapPopover>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span>
                      <Button
                        className={classes.button}
                        onClick={(e) => handleShareModalInit(e, flag)}
                        disabled={isUnmatchedFlag(flag?.trackPosition)}
                        style={{
                          pointerEvents: isUnmatchedFlag(flag?.trackPosition)
                            ? 'auto'
                            : 'unset'
                        }}
                      >
                        <ShareButtonSvg fill="#7d7d7f" height="20" />
                      </Button>
                    </span>
                  </OverlayTrigger>
                )}
                <Button
                  className={classes.button}
                  onClick={(e) => {
                    setIsSelectedFlags1(false);
                    initializePollyProcess(
                      e,
                      flagsToPlay,
                      false,
                      handleFlagPlay
                    );
                    handleClose();
                  }}
                >
                  <PlayButtonSvg fill="#7d7d7f" />
                </Button>
                {flag && (isAITag(flag.tag) || isRetrievalTag(flag.tag)) ? (
                  <></>
                ) : (
                  <Button
                    className={classes.button}
                    onClick={(e) => {
                      handleSelectedDelete(e, [flag]);
                      handleClose();
                    }}
                  >
                    <DeleteButtonSvg
                      stroke="#7d7d7f"
                      fill="none"
                      width={20}
                      height={20}
                    />
                  </Button>
                )}
              </div>
            </Popover>
            {shareModalOpen && (
              <ShareFlags
                open={shareModalOpen}
                onClose={handleShareModalClose}
                flagsToShare={flagsToShare}
              />
            )}
          </div>
        </>
      )}

      <FlagRowInPdfViewer
        flag={flag}
        handleItemSelect={handleItemSelect}
        hiddenSelectionCheckbox={hiddenSelectionCheckbox}
        handleFlagPlay={handleFlagPlay}
        citationData={citationData}
        isFromPdfViewerPage={isFromPdfViewerPage}
      />
      {/* {isRetrievalTag(note?.tag) ? (
        note?.dictation ? (
          <RetrievalFeedback tag={note?.tag} dictation={note?.dictation} />
      {isRetrievalTag(flag?.tag) ? (
        flag?.dictation ? (
          <RetrievalFeedback tag={flag?.tag} dictation={flag?.dictation} />
        ) : null
      ) : (
          <FlagRowFooterInPdfViewer
            flag={flag}
            handleRefreshPdfViewer={handleRefreshPdfViewer}
          />
      )} */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserGroups: async (token, values) => {
      await dispatch(fetchUserGroups(token, values));
    },
    setColorUserFields: async (token, values) => {
      await dispatch(updateUserFields(token, values));
    }
  };
};

const mapStateToProps = (state) => ({
  userGroups: state.app.userGroups
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlagRowHeaderInPdfViewer);
